import React from "react";
import { Box } from "@mantine/core";
import { Item } from "./Item";

export function FilterItem({ filter,selected,name, ...props }: any) {
    return (
        <div
        style={{
        padding: "24px 16px",
        display: "flex",
        flexDirection: "column",
        marginTop: 8,
        width: "100%",
    }}>
        <h2 style={{ margin: 0, padding: "0 16px" }}>{name}</h2>
            <div
                style={{
                    backgroundColor: "#e2f6ec",
                    borderRadius: 16,
                    maxHeight: "80%",
                    padding: 16,
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                    marginTop: 8,
                    width: "20rem",
                }}
            >
        <Box
            sx={() => ({
                overflow: "auto",
            })}
                >
                    {filter?.map((filt: any, index: any) => (
                        <Item filter={filt} index={index} selected={selected} {...props} />
            ))}
                </Box>
        </div>

    </div>);
}